/* The CSSP Tracker - chart + live-data engine.
   Hydrates from the SM3 Dashboard public endpoint (index relatives only);
   falls back to the frozen launch state (FALLBACK below) if the endpoint is
   unreachable, so the page never renders empty. Vanilla JS, no dependencies.
   Ported from the approved mockup (mockups/cssp-tracker.html).
   FR sibling: the same file serves /fr. Locale comes from the layout's
   <html lang>; every user-facing string lives in the S table and the data
   logic never forks. FR numbers render with a comma decimal via fnum(). */
(function () {
  'use strict';

  var root = document.getElementById('cssp-root');
  if (!root) return;

  var C = { cad: '#16181d', usa: '#a9683a', ovr: '#8a9099', grid: '#ececec', axis: '#c9c9c9', label: '#6a6f78', brand: '#c00000' };
  var NS = 'http://www.w3.org/2000/svg';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FR = (document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('fr') === 0;
  var LOC = FR ? 'fr-CA' : 'en-CA';
  function fnum(x, d) { var s = x.toFixed(d == null ? 2 : d); return FR ? s.replace('.', ',') : s; }
  var S = FR ? {
    liveIndex: 'Indice en direct', updated: 'mis à jour le ', monthly: ' · lecture mensuelle le 10',
    day: 'Jour {n} du programme',
    cite: "Metals 'R' Us, The CSSP Tracker (Le suivi CSSP), lecture du {d}. metalsrus.ca/fr/pages/cssp-tracker. Sous licence CC BY 4.0.",
    dailyPoint: ' point quotidien', dailyPoints: ' points quotidiens', nextReading: ' · prochaine lecture mensuelle : ',
    ptsSinceLaunch: ' pts depuis le lancement',
    beforeProgram: 'AVANT LE PROGRAMME', launch: 'LANCEMENT', endZone: ['FIN DU', 'PROGRAMME'],
    annLive: 'Toutes les origines rebasées à 100 au lancement; suivi à la pièce ensuite.',
    annDegraded: "Les données en direct sont brièvement indisponibles; voici l'état au lancement.",
    lblCad: 'canadien ', lblUsa: ' · é.-u. ', lblOvr: 'outre-mer ', lblGap: ' · écart ',
    preHistory: ' · historique avant programme', liveReading: ' · lecture en direct',
    promiseShort: 'la promesse, 26 nov. 2025', promiseLong: 'La promesse sur le fret est faite, le 26 nov. 2025',
    scSteel: 'acier', scNonFerrous: 'non ferreux', scMill: 'acier départ usine ', scNF: ' · non ferreux ',
    scRebased: '<br>rebasé nov. 2025 = 100', pctSign: ' %',
    events: [
      { t: "Début de l'historique des coûts", n: 'Notre système de prix commence à enregistrer les coûts quotidiens, attribués plus tard par origine à la pièce.' },
      { t: 'Le programme de 100 M$ ouvre', n: "Le remboursement de fret CSSP d'Ottawa entre en vigueur : 50 % de retour sur le fret ferroviaire et maritime admissible. Base gelée; chaque origine rebasée à 100." },
      { t: 'Webinaires de Transports Canada', n: 'TC guide les expéditeurs dans le processus de réclamation, du 13 au 18 août.' },
      { t: 'Lecture no 2', n: "Premier mois de données. Le plus tôt qu'un signal de transfert pourrait paraître." },
      { t: 'Fin prévue du programme', n: "Été 2027, à moins que le fonds de 100 M$ s'épuise avant." }
    ]
  } : {
    liveIndex: 'Live index', updated: 'updated ', monthly: ' · monthly reading on the 10th',
    day: 'Day {n} of the program',
    cite: "Metals 'R' Us, The CSSP Tracker, reading of {d}. metalsrus.ca/pages/cssp-tracker. Licensed CC BY 4.0.",
    dailyPoint: ' daily point', dailyPoints: ' daily points', nextReading: ' · next monthly reading: ',
    ptsSinceLaunch: ' pts since launch',
    beforeProgram: 'BEFORE THE PROGRAM', launch: 'LAUNCH', endZone: ['PROGRAM', 'END ZONE'],
    annLive: 'All origins rebased to 100 at launch; log-exact from here.',
    annDegraded: 'Live data is briefly unavailable; showing the launch state.',
    lblCad: 'canadian ', lblUsa: ' · us ', lblOvr: 'overseas ', lblGap: ' · gap ',
    preHistory: ' · pre-program history', liveReading: ' · live reading',
    promiseShort: 'the promise, Nov 26, 2025', promiseLong: 'The freight promise is made, Nov 26, 2025',
    scSteel: 'steel', scNonFerrous: 'non-ferrous', scMill: 'mill-gate steel ', scNF: ' · non-ferrous ',
    scRebased: '<br>rebased Nov 2025 = 100', pctSign: '%',
    events: [
      { t: 'Cost history begins', n: 'Our pricing system starts recording daily costs, later attributed by origin at the log level.' },
      { t: 'The $100M program opens', n: "Ottawa's CSSP steel freight rebate takes effect: 50% back on eligible rail and marine freight. Baseline frozen; every origin rebased to 100." },
      { t: 'Transport Canada webinars', n: 'TC walks shippers through the claim process, Aug 13-18.' },
      { t: 'Reading No. 2', n: 'First monthly reading under the program: the earliest a passthrough signal could show.' },
      { t: 'Scheduled program end', n: 'Summer 2027, unless the $100M fund exhausts first.' }
    ]
  };
  function mk(t, a) { var e = document.createElementNS(NS, t); for (var k in a) e.setAttribute(k, a[k]); return e; }
  function fmtDate(s) { return new Date(s + 'T00:00:00Z').toLocaleDateString(LOC, { timeZone: 'UTC', year: 'numeric', month: 'short', day: 'numeric' }); }
  // The endpoint omits `gap` on the baseline row; derive it from the shelf
  // relatives (cad minus combined imports) whenever it's missing.
  function gapOf(row) {
    if (!row) return null;
    if (row.gap != null) return row.gap;
    if (row.shelf && row.shelf.cad != null && row.shelf.imp != null) return Math.round((row.shelf.cad - row.shelf.imp) * 100) / 100;
    return null;
  }

  // Dates and flags are single-sourced; titles and stories come from S.events
  // so the FR page shares the exact same event data.
  var EVENTS = [
    { date: '2026-05-30' },
    { date: '2026-08-10', today: true },
    { date: '2026-08-15' },
    { date: '2026-09-10' },
    { date: '2027-07-15' }
  ].map(function (ev, i) { ev.title = S.events[i].t; ev.name = S.events[i].n; return ev; });

  var FALLBACK = {"baseline":"2026-08-10","prelaunch":{"points":[{"date":"2026-05-30","cad":93.78,"usa":96.7,"ovr":98.02,"imp":96.76},{"date":"2026-05-31","cad":93.78,"usa":96.7,"ovr":98.02,"imp":96.76},{"date":"2026-06-01","cad":93.78,"usa":96.7,"ovr":98.02,"imp":96.76},{"date":"2026-06-02","cad":93.93,"usa":96.7,"ovr":97.99,"imp":96.71},{"date":"2026-06-03","cad":93.93,"usa":96.7,"ovr":97.96,"imp":96.69},{"date":"2026-06-04","cad":94.46,"usa":96.7,"ovr":97.96,"imp":96.69},{"date":"2026-06-05","cad":94.91,"usa":96.7,"ovr":98.14,"imp":96.81},{"date":"2026-06-06","cad":94.91,"usa":96.7,"ovr":98.14,"imp":96.81},{"date":"2026-06-07","cad":94.99,"usa":96.7,"ovr":98.15,"imp":96.83},{"date":"2026-06-08","cad":94.99,"usa":96.7,"ovr":98.15,"imp":96.83},{"date":"2026-06-09","cad":94.99,"usa":96.7,"ovr":98.15,"imp":96.83},{"date":"2026-06-10","cad":95.18,"usa":96.7,"ovr":98.2,"imp":96.81},{"date":"2026-06-11","cad":95.23,"usa":99.89,"ovr":98.2,"imp":97.11},{"date":"2026-06-12","cad":95.23,"usa":99.89,"ovr":98.2,"imp":97.11},{"date":"2026-06-13","cad":95.23,"usa":99.89,"ovr":98.2,"imp":97.11},{"date":"2026-06-14","cad":95.23,"usa":99.89,"ovr":98.2,"imp":97.11},{"date":"2026-06-15","cad":95.23,"usa":99.89,"ovr":98.2,"imp":97.11},{"date":"2026-06-16","cad":95.26,"usa":99.92,"ovr":98.23,"imp":97.15},{"date":"2026-06-17","cad":95.26,"usa":99.92,"ovr":98.23,"imp":97.15},{"date":"2026-06-18","cad":96.29,"usa":99.92,"ovr":98.39,"imp":97.25},{"date":"2026-06-19","cad":96.29,"usa":99.92,"ovr":98.39,"imp":97.25},{"date":"2026-06-20","cad":96.29,"usa":99.92,"ovr":98.39,"imp":97.25},{"date":"2026-06-21","cad":96.29,"usa":99.92,"ovr":98.39,"imp":97.25},{"date":"2026-06-22","cad":96.29,"usa":99.92,"ovr":98.39,"imp":97.25},{"date":"2026-06-23","cad":96.29,"usa":99.92,"ovr":98.39,"imp":97.25},{"date":"2026-06-24","cad":96.29,"usa":99.92,"ovr":98.39,"imp":97.25},{"date":"2026-06-25","cad":96.42,"usa":99.92,"ovr":98.79,"imp":97.89},{"date":"2026-06-26","cad":96.67,"usa":99.92,"ovr":99.14,"imp":98.29},{"date":"2026-06-27","cad":96.67,"usa":99.92,"ovr":99.14,"imp":98.29},{"date":"2026-06-28","cad":96.67,"usa":99.92,"ovr":99.14,"imp":98.29},{"date":"2026-06-29","cad":96.67,"usa":100.02,"ovr":99.14,"imp":98.73},{"date":"2026-06-30","cad":96.67,"usa":100.02,"ovr":99.14,"imp":98.73},{"date":"2026-07-01","cad":96.69,"usa":100.02,"ovr":99.45,"imp":99.19},{"date":"2026-07-02","cad":96.69,"usa":100.02,"ovr":99.45,"imp":99.19},{"date":"2026-07-03","cad":96.69,"usa":100.02,"ovr":99.53,"imp":99.38},{"date":"2026-07-04","cad":96.69,"usa":100.02,"ovr":99.53,"imp":99.38},{"date":"2026-07-05","cad":96.69,"usa":100.02,"ovr":99.53,"imp":99.38},{"date":"2026-07-06","cad":96.69,"usa":100.02,"ovr":99.53,"imp":99.38},{"date":"2026-07-07","cad":97.09,"usa":100.02,"ovr":99.56,"imp":99.39},{"date":"2026-07-08","cad":97.09,"usa":100.02,"ovr":99.56,"imp":99.4},{"date":"2026-07-09","cad":97.09,"usa":100.02,"ovr":99.4,"imp":99.2},{"date":"2026-07-10","cad":97.59,"usa":100.0,"ovr":99.13,"imp":99.0},{"date":"2026-07-11","cad":97.59,"usa":100.0,"ovr":99.13,"imp":99.0},{"date":"2026-07-12","cad":97.59,"usa":100.0,"ovr":99.13,"imp":99.0},{"date":"2026-07-13","cad":97.59,"usa":100.0,"ovr":99.13,"imp":99.0},{"date":"2026-07-14","cad":97.62,"usa":100.0,"ovr":99.22,"imp":99.44},{"date":"2026-07-15","cad":97.62,"usa":100.0,"ovr":99.22,"imp":99.44},{"date":"2026-07-16","cad":97.62,"usa":100.0,"ovr":99.22,"imp":99.44},{"date":"2026-07-17","cad":97.99,"usa":100.0,"ovr":99.34,"imp":99.53},{"date":"2026-07-18","cad":97.99,"usa":100.0,"ovr":98.97,"imp":99.28},{"date":"2026-07-19","cad":97.99,"usa":100.0,"ovr":98.97,"imp":99.28},{"date":"2026-07-20","cad":97.99,"usa":100.09,"ovr":99.13,"imp":99.4},{"date":"2026-07-21","cad":98.13,"usa":100.09,"ovr":99.13,"imp":99.4},{"date":"2026-07-22","cad":98.13,"usa":100.09,"ovr":99.13,"imp":99.4},{"date":"2026-07-23","cad":98.1,"usa":100.0,"ovr":99.21,"imp":99.44},{"date":"2026-07-24","cad":98.27,"usa":100.0,"ovr":99.21,"imp":99.44},{"date":"2026-07-25","cad":98.27,"usa":100.0,"ovr":99.21,"imp":99.44},{"date":"2026-07-26","cad":98.27,"usa":100.0,"ovr":99.21,"imp":99.44},{"date":"2026-07-27","cad":98.27,"usa":100.0,"ovr":99.21,"imp":99.44},{"date":"2026-07-28","cad":98.27,"usa":100.0,"ovr":99.21,"imp":99.44},{"date":"2026-07-29","cad":99.03,"usa":100.0,"ovr":99.24,"imp":99.4},{"date":"2026-07-30","cad":99.03,"usa":100.0,"ovr":99.5,"imp":99.58},{"date":"2026-07-31","cad":99.33,"usa":100.0,"ovr":99.5,"imp":99.57},{"date":"2026-08-01","cad":99.33,"usa":100.0,"ovr":99.5,"imp":99.57},{"date":"2026-08-02","cad":99.33,"usa":100.0,"ovr":99.5,"imp":99.57},{"date":"2026-08-03","cad":100.0,"usa":100.0,"ovr":99.51,"imp":99.58},{"date":"2026-08-04","cad":100.0,"usa":100.0,"ovr":99.51,"imp":99.58},{"date":"2026-08-05","cad":100.0,"usa":100.0,"ovr":99.51,"imp":99.54},{"date":"2026-08-06","cad":100.0,"usa":100.0,"ovr":100.0,"imp":100.0},{"date":"2026-08-07","cad":100.0,"usa":100.0,"ovr":100.0,"imp":100.0},{"date":"2026-08-08","cad":100.0,"usa":100.0,"ovr":100.0,"imp":100.0},{"date":"2026-08-09","cad":100.0,"usa":100.0,"ovr":100.0,"imp":100.0},{"date":"2026-08-10","cad":100.0,"usa":100.0,"ovr":100.0,"imp":100.0}]},"series":[{"date":"2026-08-10","shelf":{"cad":100.0,"usa":100.0,"ovr":100.0,"imp":100.0},"fresh":{"cad":null,"usa":null,"ovr":null,"imp":null},"gap":0.0,"missing_origin_pct":9.0},{"date":"2026-08-11","shelf":{"cad":100.01,"usa":99.99,"ovr":99.98,"imp":99.99},"fresh":{"cad":null,"usa":null,"ovr":null,"imp":null},"gap":0.02,"missing_origin_pct":9.0}],"statcan":{"series":{"ferrous":{"vector":1230995997,"points":[{"date":"2024-01-01","value":141.4},{"date":"2024-02-01","value":146.1},{"date":"2024-03-01","value":145.6},{"date":"2024-04-01","value":143.5},{"date":"2024-05-01","value":143.4},{"date":"2024-06-01","value":141.6},{"date":"2024-07-01","value":138.8},{"date":"2024-08-01","value":135.5},{"date":"2024-09-01","value":134},{"date":"2024-10-01","value":133.9},{"date":"2024-11-01","value":134.1},{"date":"2024-12-01","value":134},{"date":"2025-01-01","value":133.6},{"date":"2025-02-01","value":133.3},{"date":"2025-03-01","value":136},{"date":"2025-04-01","value":136.5},{"date":"2025-05-01","value":136.4},{"date":"2025-06-01","value":133.2},{"date":"2025-07-01","value":128.9},{"date":"2025-08-01","value":128.9},{"date":"2025-09-01","value":129},{"date":"2025-10-01","value":131.8},{"date":"2025-11-01","value":128.4},{"date":"2025-12-01","value":128.2},{"date":"2026-01-01","value":130.5},{"date":"2026-02-01","value":134.2},{"date":"2026-03-01","value":136.9},{"date":"2026-04-01","value":133.1},{"date":"2026-05-01","value":133.7},{"date":"2026-06-01","value":134.5}]},"nonferrous":{"vector":1230995998,"points":[{"date":"2024-01-01","value":135.5},{"date":"2024-02-01","value":135},{"date":"2024-03-01","value":141.2},{"date":"2024-04-01","value":152.8},{"date":"2024-05-01","value":160.1},{"date":"2024-06-01","value":159.2},{"date":"2024-07-01","value":159.4},{"date":"2024-08-01","value":156.8},{"date":"2024-09-01","value":158},{"date":"2024-10-01","value":166.9},{"date":"2024-11-01","value":165.5},{"date":"2024-12-01","value":166.8},{"date":"2025-01-01","value":168.4},{"date":"2025-02-01","value":173.6},{"date":"2025-03-01","value":180.2},{"date":"2025-04-01","value":175.7},{"date":"2025-05-01","value":177.1},{"date":"2025-06-01","value":182},{"date":"2025-07-01","value":187},{"date":"2025-08-01","value":188.2},{"date":"2025-09-01","value":199.1},{"date":"2025-10-01","value":219.3},{"date":"2025-11-01","value":221.8},{"date":"2025-12-01","value":237.8},{"date":"2026-01-01","value":280.4},{"date":"2026-02-01","value":270.5},{"date":"2026-03-01","value":266},{"date":"2026-04-01","value":267.3},{"date":"2026-05-01","value":270.5},{"date":"2026-06-01","value":257.8}]}}}};

  var endpoint = root.getAttribute('data-endpoint') || '';
  if (endpoint && window.fetch) {
    fetch(endpoint, { cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('bad status'); return r.json(); })
      .then(function (d) { init(d, false); })
      .catch(function () { init(FALLBACK, true); });
  } else {
    init(FALLBACK, true);
  }

  function init(data, degraded) {
    var hist = (data.prelaunch && data.prelaunch.points) || [];
    var series = data.series || [];
    var latest = series.length ? series[series.length - 1] : null;
    try { renderStamp(series, latest); } catch (e) { /* keep rendering */ }
    try { renderTiles(series, latest); } catch (e) { /* keep rendering */ }
    try { gapMeter(latest); } catch (e) { /* keep rendering */ }
    try { mainChart(hist, series, degraded); } catch (e) { /* keep rendering */ }
    try { scChart(data.statcan); } catch (e) { /* keep rendering */ }
    countUp();
    reveal();
    ticker();
  }

  /* ── masthead + cite live text ── */
  function nextTenth(dateStr) {
    var d = new Date(dateStr + 'T00:00:00Z');
    var y = d.getUTCFullYear(); var m = d.getUTCMonth();
    if (d.getUTCDate() >= 10) m += 1;
    var n = new Date(Date.UTC(y, m, 10));
    return n.toISOString().slice(0, 10);
  }
  function renderStamp(series, latest) {
    if (!latest) return;
    var stamp = document.getElementById('cssp-stamp');
    if (stamp) stamp.innerHTML = '<b>' + S.liveIndex + '</b> · ' + S.updated + fmtDate(latest.date) + S.monthly;
    var days = Math.max(1, Math.round((new Date(latest.date + 'T00:00:00Z') - new Date('2026-08-10T00:00:00Z')) / 86400000) + 1);
    var head = document.getElementById('rc-headline');
    if (head) head.textContent = S.day.replace('{n}', days);
    var next = document.getElementById('rc-next');
    if (next) next.textContent = fmtDate(nextTenth(latest.date));
    var cite = document.getElementById('cssp-cite');
    if (cite) cite.textContent = S.cite.replace('{d}', fmtDate(latest.date));
    var foot = document.getElementById('chart-foot-count');
    if (foot) foot.textContent = series.length + (series.length === 1 ? S.dailyPoint : S.dailyPoints) + S.nextReading + fmtDate(nextTenth(latest.date));
  }

  /* ── tiles ── */
  function renderTiles(series, latest) {
    if (!latest) return;
    ['cad', 'usa', 'ovr'].forEach(function (key) {
      var tile = root.querySelector('.tile[data-series="' + key + '"]');
      if (!tile) return;
      var v = latest.shelf ? latest.shelf[key] : null;
      if (v == null) return;
      var num = tile.querySelector('.t-num');
      if (num) num.setAttribute('data-count', v.toFixed(2));
      if (series.length > 1) {
        var delta = tile.querySelector('.t-delta');
        var diff = v - 100;
        if (delta) delta.textContent = (diff >= 0 ? '+' : '') + fnum(diff) + S.ptsSinceLaunch;
      }
    });
  }

  /* ── gap meter ── */
  function gapMeter(latest) {
    var svg = document.getElementById('gapMeter');
    if (!svg) return;
    var gap = gapOf(latest);
    if (gap == null) gap = 0;
    var gn = document.getElementById('gapNum');
    if (gn) gn.innerHTML = fnum(gap) + '<small> pts</small>';
    var W = 720, L = 26, R = 26, axisY = 58;
    for (var v = -5; v <= 5; v++) {
      var x = L + (v + 5) / 10 * (W - L - R);
      svg.appendChild(mk('line', { x1: x, x2: x, y1: axisY - (v === 0 ? 16 : 9), y2: axisY, stroke: v === 0 ? '#16181d' : '#c9c9c9', 'stroke-width': v === 0 ? 2 : 1 }));
      var t = mk('text', { x: x, y: axisY + 18, 'text-anchor': 'middle', fill: '#6a6f78', 'font-size': '11', 'font-family': 'IBM Plex Mono' });
      t.textContent = (v > 0 ? '+' : '') + v;
      svg.appendChild(t);
    }
    svg.appendChild(mk('line', { x1: L, x2: W - R, y1: axisY, y2: axisY, stroke: '#9aa0a8', 'stroke-width': 1.4 }));
    var clamped = Math.max(-5, Math.min(5, gap));
    var tx = L + (clamped + 5) / 10 * (W - L - R);
    var needle = mk('path', { d: 'M0 -26 L7 -12 L1.8 -12 L1.8 0 L-1.8 0 L-1.8 -12 L-7 -12 Z', fill: '#16181d', transform: 'translate(' + tx + ',' + axisY + ')' });
    svg.appendChild(needle);
    if (!reduce) {
      var from = Math.max(L, tx - 120); var start = null;
      needle.setAttribute('transform', 'translate(' + from + ',' + axisY + ')');
      var step = function (ts) {
        if (start === null) start = ts;
        var p = Math.min(1, (ts - start) / 900);
        var ease = 1 - Math.pow(1 - p, 3);
        needle.setAttribute('transform', 'translate(' + (from + (tx - from) * ease) + ',' + axisY + ')');
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }
    // When the meter scrolls (phone widths), open with the needle centred so
    // the reading and both directions are in view, not the far negative end.
    var wrap = svg.closest('.g-scalewrap');
    if (wrap && wrap.scrollWidth > wrap.clientWidth + 4) {
      wrap.scrollLeft = Math.max(0, tx / W * svg.clientWidth - wrap.clientWidth / 2);
    }
  }

  /* ── main tracker chart ── */
  function mainChart(hist, series, degraded) {
    var svg = document.getElementById('mainChart'), tt = document.getElementById('mainTT');
    if (!svg) return;
    // T leaves a marker gutter above the plot: launch chip on one row, event
    // diamonds on the row below it, so neither can collide with the other or
    // with the band labels inside the plot.
    var W = 1080, H = 430, L = 64, R = 24, T = 46, B = 54;
    var t0 = new Date('2026-05-30T00:00:00Z').getTime(), t1 = new Date('2027-08-10T00:00:00Z').getTime();
    var tL = new Date('2026-08-10T00:00:00Z').getTime();
    var vals = [92, 104];
    series.forEach(function (p) {
      ['cad', 'usa', 'ovr'].forEach(function (k) {
        var v = p.shelf && p.shelf[k];
        if (v != null) { vals[0] = Math.min(vals[0], Math.floor(v) - 1); vals[1] = Math.max(vals[1], Math.ceil(v) + 1); }
      });
    });
    var y0 = vals[0], y1 = vals[1];
    function X(d) { return L + (new Date(d + 'T00:00:00Z').getTime() - t0) / (t1 - t0) * (W - L - R); }
    function Y(v) { return T + (y1 - v) / (y1 - y0) * (H - T - B); }

    var defs = mk('defs', {});
    var pat = mk('pattern', { id: 'gp', width: '28', height: '28', patternUnits: 'userSpaceOnUse' });
    pat.appendChild(mk('path', { d: 'M28 0H0V28', fill: 'none', stroke: '#f4f4f4', 'stroke-width': '1' }));
    defs.appendChild(pat);
    svg.appendChild(defs);
    svg.appendChild(mk('rect', { x: L, y: T, width: W - L - R, height: H - T - B, fill: 'url(#gp)' }));

    var xL = X('2026-08-10');
    svg.appendChild(mk('rect', { x: L, y: T, width: xL - L, height: H - T - B, fill: '#f6f6f6', opacity: 0.55 }));
    var bl = mk('text', { x: L + (xL - L) / 2, y: T + 16, 'text-anchor': 'middle', fill: C.label, 'font-size': '10', 'font-family': 'Montserrat', 'font-weight': '700', 'letter-spacing': '.08em' });
    bl.textContent = S.beforeProgram;
    svg.appendChild(bl);

    var yStep = (y1 - y0) > 16 ? 4 : 2;
    for (var v = y0; v <= y1; v += yStep) {
      var strong = v === 100;
      svg.appendChild(mk('line', { x1: L, x2: W - R, y1: Y(v), y2: Y(v), stroke: strong ? '#b9b9b9' : C.grid, 'stroke-width': strong ? 1.4 : 1 }));
      var yt = mk('text', { x: L - 10, y: Y(v) + 4, 'text-anchor': 'end', fill: C.label, 'font-size': '12', 'font-family': 'IBM Plex Mono' });
      yt.textContent = String(v);
      svg.appendChild(yt);
    }
    var yearShown = null;
    for (var m = 0; m <= 14; m++) {
      var d = new Date(Date.UTC(2026, 5 + m, 1));
      var x = X(d.toISOString().slice(0, 10));
      if (x < L) continue;
      svg.appendChild(mk('line', { x1: x, x2: x, y1: H - B, y2: H - B + 6, stroke: C.axis }));
      if (m % 2 === 0) {
        var lab = d.toLocaleString(LOC, { timeZone: 'UTC', month: 'short' });
        if (yearShown !== d.getUTCFullYear()) { lab += " '" + String(d.getUTCFullYear()).slice(2); yearShown = d.getUTCFullYear(); }
        var mt = mk('text', { x: x, y: H - B + 22, 'text-anchor': 'middle', fill: C.label, 'font-size': '11.5', 'font-family': 'IBM Plex Mono' });
        mt.textContent = lab;
        svg.appendChild(mt);
      }
    }
    svg.appendChild(mk('line', { x1: L, x2: W - R, y1: H - B, y2: H - B, stroke: '#9aa0a8', 'stroke-width': 1.2 }));

    var zx = X('2027-06-20');
    svg.appendChild(mk('rect', { x: zx, y: T, width: (W - R) - zx, height: H - T - B, fill: '#f6f6f6', opacity: 0.7 }));

    EVENTS.forEach(function (ev) {
      var x = X(ev.date);
      if (x < L || x > W - R) return;
      if (ev.today) {
        // Chip rides its own row in the gutter; the red line hangs from it.
        svg.appendChild(mk('line', { x1: x, x2: x, y1: 22, y2: H - B, stroke: C.brand, 'stroke-width': 1.4 }));
        // Chip width follows the label so LANCEMENT fits on the FR page
        // (EN resolves to the original 54).
        var cw = S.launch.length * 7 + 12;
        svg.appendChild(mk('rect', { x: x - cw / 2, y: 4, width: cw, height: 18, fill: C.brand }));
        var ct = mk('text', { x: x, y: 17, 'text-anchor': 'middle', fill: '#fff', 'font-size': '9.5', 'font-family': 'Montserrat', 'font-weight': '800', 'letter-spacing': '.1em' });
        ct.textContent = S.launch;
        svg.appendChild(ct);
      } else {
        // Visible marker so events are discoverable before you hover them.
        // Diamonds sit on the gutter row below the chip: same-x overlap is impossible.
        svg.appendChild(mk('line', { x1: x, x2: x, y1: 40, y2: H - B, stroke: '#c4c8ce', 'stroke-width': 1, 'stroke-dasharray': '3 4' }));
        svg.appendChild(mk('path', { d: 'M' + x + ' 26 l5 6 l-5 6 l-5 -6 Z', fill: '#fff', stroke: '#9aa0a8', 'stroke-width': 1.4 }));
      }
    });

    // End-zone label drawn after the event lines, on a backing that matches the
    // zone fill, so the program-end line can't strike through the words.
    var zcx = zx + ((W - R) - zx) / 2;
    svg.appendChild(mk('rect', { x: zcx - 36, y: T + 4, width: 72, height: 28, fill: '#f7f7f7' }));
    S.endZone.forEach(function (word, i) {
      var zt = mk('text', { x: zcx, y: T + 14 + i * 12, 'text-anchor': 'middle', fill: C.label, 'font-size': '10', 'font-family': 'Montserrat', 'font-weight': '700' });
      zt.textContent = word;
      svg.appendChild(zt);
    });

    var groups = {};
    ['ovr', 'usa', 'cad'].forEach(function (key) {
      var g = mk('g', { 'data-g': key });
      var wgt = key === 'cad' ? 3 : 2.2;
      if (hist.length) {
        var dh = hist.map(function (r, i) { return (i ? 'L' : 'M') + X(r.date) + ' ' + Y(r[key]); }).join(' ');
        g.appendChild(mk('path', { d: dh, fill: 'none', stroke: C[key], 'stroke-width': wgt, 'stroke-dasharray': '5 4', 'stroke-linejoin': 'round' }));
      }
      var pts = series.filter(function (p) { return p.shelf && p.shelf[key] != null; });
      if (pts.length > 1) {
        var ds = pts.map(function (p, i) { return (i ? 'L' : 'M') + X(p.date) + ' ' + Y(p.shelf[key]); }).join(' ');
        g.appendChild(mk('path', { d: ds, fill: 'none', stroke: C[key], 'stroke-width': wgt, 'stroke-linejoin': 'round' }));
      }
      var dots = pts.length <= 30 ? pts : [pts[pts.length - 1]];
      dots.forEach(function (p) {
        g.appendChild(mk('circle', { cx: X(p.date), cy: Y(p.shelf[key]), r: key === 'cad' ? 5 : 4, fill: C[key], stroke: '#fff', 'stroke-width': 2 }));
      });
      svg.appendChild(g);
      groups[key] = g;
    });

    var ann = mk('text', { x: xL + 14, y: Y(100) - 46, fill: '#3c4048', 'font-size': '13', 'font-family': 'Newsreader', 'font-style': 'italic' });
    ann.textContent = degraded ? S.annDegraded : S.annLive;
    svg.appendChild(ann);
    svg.appendChild(mk('line', { x1: xL + 10, y1: Y(100) - 42, x2: xL + 3, y2: Y(100) - 8, stroke: '#9aa0a8' }));

    root.querySelectorAll('.lg').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var on = btn.getAttribute('aria-pressed') === 'true';
        btn.setAttribute('aria-pressed', String(!on));
        if (groups[btn.getAttribute('data-series')]) groups[btn.getAttribute('data-series')].style.opacity = on ? 0 : 1;
      });
    });

    var cross = mk('line', { x1: 0, x2: 0, y1: T, y2: H - B, stroke: '#9aa0a8', 'stroke-dasharray': '2 3', opacity: 0 });
    svg.appendChild(cross);
    // Live tracking dots: one per series, ride the crosshair.
    var hoverDots = {};
    ['ovr', 'usa', 'cad'].forEach(function (key) {
      hoverDots[key] = mk('circle', { r: key === 'cad' ? 6 : 5, fill: C[key], stroke: '#fff', 'stroke-width': 2, opacity: 0, 'pointer-events': 'none' });
      svg.appendChild(hoverDots[key]);
    });
    function valuesAt(dateStr) {
      for (var i = series.length - 1; i >= 0; i--) {
        if (series[i].date === dateStr) return { cad: series[i].shelf.cad, usa: series[i].shelf.usa, ovr: series[i].shelf.ovr, gap: gapOf(series[i]) };
      }
      for (var j = hist.length - 1; j >= 0; j--) {
        if (hist[j].date === dateStr) return { cad: hist[j].cad, usa: hist[j].usa, ovr: hist[j].ovr, gap: Math.round((hist[j].cad - hist[j].imp) * 100) / 100 };
      }
      return null;
    }
    function valueLine(v) {
      if (!v) return '';
      var f = function (x) { return x == null ? '·' : fnum(x); };
      return '<br>' + S.lblCad + f(v.cad) + S.lblUsa + f(v.usa) + '<br>' + S.lblOvr + f(v.ovr) + S.lblGap + (v.gap == null ? '·' : fnum(v.gap) + ' pts');
    }
    svg.addEventListener('mousemove', function (e) {
      var pt = svg.createSVGPoint();
      pt.x = e.clientX; pt.y = e.clientY;
      var p = pt.matrixTransform(svg.getScreenCTM().inverse());
      if (p.x < L || p.x > W - R) { hideHover(); return; }
      var best = null, bd = 1e12;
      hist.forEach(function (r) { var d = Math.abs(X(r.date) - p.x); if (d < bd) { bd = d; best = { type: 'h', o: r }; } });
      series.forEach(function (r) { var d = Math.abs(X(r.date) - p.x); if (d < bd) { bd = d; best = { type: 'r', o: r }; } });
      // Events win inside a generous radius: they carry the story.
      var evBest = null, evd = 1e12;
      EVENTS.forEach(function (ev) { var d = Math.abs(X(ev.date) - p.x); if (d < evd) { evd = d; evBest = ev; } });
      if (evBest && evd <= 14) best = { type: 'e', o: evBest };
      if (!best) { hideHover(); return; }
      var bdate = best.o.date;
      var bx = X(bdate);
      cross.setAttribute('x1', bx); cross.setAttribute('x2', bx); cross.setAttribute('opacity', 1);
      var vals = valuesAt(bdate) || (best.type === 'h' ? valuesAt(best.o.date) : null);
      // Dots track whichever date is highlighted (events included, when data exists).
      var dotVals = vals || (best.type === 'e' ? null : vals);
      ['cad', 'usa', 'ovr'].forEach(function (key) {
        var v = dotVals ? dotVals[key] : null;
        var g = groups[key];
        var visible = g && g.style.opacity !== '0';
        if (v == null || !visible) { hoverDots[key].setAttribute('opacity', 0); return; }
        hoverDots[key].setAttribute('cx', bx);
        hoverDots[key].setAttribute('cy', Y(v));
        hoverDots[key].setAttribute('opacity', 1);
      });
      var html;
      if (best.type === 'e') {
        var cls = best.o.today ? 'tt-ev tt-ev--launch' : 'tt-ev';
        html = '<b>' + fmtDate(bdate) + '</b><br><span class="' + cls + '">' + best.o.title + '</span><br>' + best.o.name + valueLine(vals);
      } else if (best.type === 'h') {
        html = '<b>' + fmtDate(bdate) + S.preHistory + '</b>' + valueLine(vals);
      } else {
        html = '<b>' + fmtDate(bdate) + S.liveReading + '</b>' + valueLine(vals);
      }
      tt.innerHTML = html;
      var box = svg.getBoundingClientRect();
      var px = bx / W * box.width;
      tt.style.left = Math.min(box.width - 300, Math.max(8, px + 14)) + 'px';
      tt.style.top = (p.y / H * box.height - 10) + 'px';
      tt.style.opacity = 1;
    });
    function hideHover() {
      tt.style.opacity = 0;
      cross.setAttribute('opacity', 0);
      ['cad', 'usa', 'ovr'].forEach(function (k) { hoverDots[k].setAttribute('opacity', 0); });
    }
    svg.addEventListener('mouseleave', hideHover);
  }

  /* ── statcan backdrop ── */
  function scChart(statcan) {
    var svg = document.getElementById('scChart'), tt = document.getElementById('scTT');
    if (!svg || !statcan || !statcan.series || !statcan.series.ferrous) return;
    var F0 = statcan.series.ferrous.points, N0 = statcan.series.nonferrous.points;
    var start = '2025-01-01';
    var F = F0.filter(function (p) { return p.date >= start; });
    var N = N0.filter(function (p) { return p.date >= start; });
    var bi = F.findIndex(function (p) { return p.date === '2025-11-01'; });
    if (bi < 0 || !F.length || !N.length) return;
    var bf = F[bi].value, bn = (N[bi] || {}).value;
    if (!bf || !bn) return;
    var Fr = F.map(function (p) { return { date: p.date, v: p.value / bf * 100 }; });
    var Nr = N.map(function (p) { return { date: p.date, v: p.value / bn * 100 }; });
    var all = Fr.concat(Nr).map(function (p) { return p.v; });
    var y0 = Math.floor(Math.min.apply(null, all) / 5) * 5 - 2;
    var y1 = Math.ceil(Math.max.apply(null, all) / 5) * 5 + 2;
    // R holds the end labels; "non-ferrous +16.2%" needs the full 155.
    var W = 1080, H = 340, L = 64, R = 155, T = 26, B = 44;
    var n = Fr.length;
    function X(i) { return L + i / (n - 1) * (W - L - R); }
    function Y(v) { return T + (y1 - v) / (y1 - y0) * (H - T - B); }
    for (var v = Math.ceil(y0 / 10) * 10; v <= y1; v += 10) {
      svg.appendChild(mk('line', { x1: L, x2: W - R, y1: Y(v), y2: Y(v), stroke: v === 100 ? '#b9b9b9' : '#ececec', 'stroke-width': v === 100 ? 1.3 : 1 }));
      var yt = mk('text', { x: L - 10, y: Y(v) + 4, 'text-anchor': 'end', fill: '#6a6f78', 'font-size': '12', 'font-family': 'IBM Plex Mono' });
      yt.textContent = String(v);
      svg.appendChild(yt);
    }
    Fr.forEach(function (p, i) {
      if (i % 3) return;
      var xt = mk('text', { x: X(i), y: H - B + 20, 'text-anchor': 'middle', fill: '#6a6f78', 'font-size': '11', 'font-family': 'IBM Plex Mono' });
      xt.textContent = p.date.slice(0, 7).replace('-', '/');
      svg.appendChild(xt);
    });
    svg.appendChild(mk('line', { x1: L, x2: W - R, y1: H - B, y2: H - B, stroke: '#9aa0a8', 'stroke-width': 1.2 }));
    svg.appendChild(mk('line', { x1: X(bi), x2: X(bi), y1: T, y2: H - B, stroke: '#c4c8ce', 'stroke-dasharray': '3 4' }));
    var pm = mk('text', { x: X(bi) + 8, y: T + 14, fill: '#6a6f78', 'font-size': '12', 'font-family': 'Newsreader', 'font-style': 'italic' });
    pm.textContent = S.promiseShort;
    svg.appendChild(pm);
    function line(data, color) {
      var d = data.map(function (p, i) { return (i ? 'L' : 'M') + X(i) + ' ' + Y(p.v); }).join(' ');
      svg.appendChild(mk('path', { d: d, fill: 'none', stroke: color, 'stroke-width': 2.6, 'stroke-linejoin': 'round' }));
      return data[data.length - 1];
    }
    var fe = line(Fr, '#16181d');
    var ne = line(Nr, '#a9683a');
    function endLab(p, color, name) {
      // Two stacked lines so the label fits the right margin at every width.
      var pct = (p.v - 100);
      [name, (pct >= 0 ? '+' : '') + fnum(pct, 1) + S.pctSign].forEach(function (line, i) {
        var t = mk('text', { x: W - R + 10, y: Y(p.v) - 3 + i * 15, fill: color, 'font-size': '12.5', 'font-family': 'IBM Plex Mono', 'font-weight': '600' });
        t.textContent = line;
        svg.appendChild(t);
      });
    }
    endLab(fe, '#16181d', S.scSteel);
    endLab(ne, '#8a5426', S.scNonFerrous);

    // Hover: crosshair + per-month tooltip, promise month highlighted.
    var cross = mk('line', { x1: 0, x2: 0, y1: T, y2: H - B, stroke: '#9aa0a8', 'stroke-dasharray': '2 3', opacity: 0 });
    svg.appendChild(cross);
    var dotF = mk('circle', { r: 5, fill: '#16181d', stroke: '#fff', 'stroke-width': 2, opacity: 0, 'pointer-events': 'none' });
    var dotN = mk('circle', { r: 5, fill: '#a9683a', stroke: '#fff', 'stroke-width': 2, opacity: 0, 'pointer-events': 'none' });
    svg.appendChild(dotF); svg.appendChild(dotN);
    function hide() { if (tt) tt.style.opacity = 0; cross.setAttribute('opacity', 0); dotF.setAttribute('opacity', 0); dotN.setAttribute('opacity', 0); }
    svg.addEventListener('mousemove', function (e) {
      if (!tt) return;
      var pt = svg.createSVGPoint();
      pt.x = e.clientX; pt.y = e.clientY;
      var p = pt.matrixTransform(svg.getScreenCTM().inverse());
      if (p.x < L || p.x > W - R) { hide(); return; }
      var i = Math.max(0, Math.min(n - 1, Math.round((p.x - L) / (W - L - R) * (n - 1))));
      var x = X(i);
      cross.setAttribute('x1', x); cross.setAttribute('x2', x); cross.setAttribute('opacity', 1);
      dotF.setAttribute('cx', x); dotF.setAttribute('cy', Y(Fr[i].v)); dotF.setAttribute('opacity', 1);
      if (Nr[i]) { dotN.setAttribute('cx', x); dotN.setAttribute('cy', Y(Nr[i].v)); dotN.setAttribute('opacity', 1); }
      var month = new Date(Fr[i].date + 'T00:00:00Z').toLocaleDateString(LOC, { timeZone: 'UTC', year: 'numeric', month: 'long' });
      var promise = i === bi ? '<br><span class="tt-ev">' + S.promiseLong + '</span>' : '';
      tt.innerHTML = '<b>' + month + '</b>' + promise +
        '<br>' + S.scMill + fnum(Fr[i].v, 1) + (Nr[i] ? S.scNF + fnum(Nr[i].v, 1) : '') +
        S.scRebased;
      var box = svg.getBoundingClientRect();
      var px = x / W * box.width;
      tt.style.left = Math.min(box.width - 280, Math.max(8, px + 14)) + 'px';
      tt.style.top = (p.y / H * box.height - 10) + 'px';
      tt.style.opacity = 1;
    });
    svg.addEventListener('mouseleave', hide);

    // When the chart scrolls (phone widths), open anchored just left of the
    // promise line: the promise and the 2026 divergence are the story, not
    // early 2025.
    var wrap = svg.closest('.svg-scroll');
    if (wrap && wrap.scrollWidth > wrap.clientWidth + 4) {
      var target = X(bi) / W * svg.clientWidth - 2;
      wrap.scrollLeft = Math.min(wrap.scrollWidth - wrap.clientWidth, Math.max(0, target));
    }
  }

  /* ── count-up, reveal, ticker ── */
  function countUp() {
    var els = root.querySelectorAll('[data-count]');
    if (reduce) { els.forEach(function (el) { el.textContent = fnum(parseFloat(el.getAttribute('data-count'))); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target, target = parseFloat(el.getAttribute('data-count'));
        var start = null;
        var step = function (ts) {
          if (start === null) start = ts;
          var p = Math.min(1, (ts - start) / 1100);
          var ease = 1 - Math.pow(1 - p, 4);
          el.textContent = fnum(target * ease);
          if (p < 1) requestAnimationFrame(step); else el.textContent = fnum(target);
        };
        requestAnimationFrame(step);
        io.unobserve(el);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }
  function reveal() {
    var els = root.querySelectorAll('.rv');
    if (reduce) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (e, i) { e.style.transitionDelay = (i % 4) * 60 + 'ms'; io.observe(e); });
  }
  function ticker() {
    var t = document.getElementById('tickerTrack');
    if (t) t.innerHTML = t.innerHTML + t.innerHTML;
  }
})();
